import React, { useMemo, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import { FilterMatchMode } from "primereact/api";

const CategoryLeftView = ({
  categoriesDataLeft,
  selectedCategories,
  setSelectedCategories,
  rowClick,
  onExactCategoryChange,
}: any) => {
  const { t } = useTranslation();

  const [filters, setFilters] = useState<any>({
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const isSearching = useMemo(
    () => !!filters?.name?.value && String(filters.name.value).trim().length > 0,
    [filters]
  );

  const handleSelectionChange = (e: any) => {
    const rows = Array.isArray(e.value) ? e.value : [e.value];
    setSelectedCategories(rows);

    if (onExactCategoryChange) {
      const ids = rows.map((r: any) => r.id ?? r.key ?? r.ID);
      onExactCategoryChange({ ids, isSearch: isSearching });
    }
  };

  return (
    <>
      {categoriesDataLeft ? (
        <div className="left-filter">
          <DataTable
            value={categoriesDataLeft}
            size="small"
            selection={selectedCategories}
            onSelectionChange={handleSelectionChange}
            dataKey="id"
            tableStyle={{ minWidth: "3rem" }}
            filters={filters}
            onFilter={(e) => setFilters(e.filters)}
          >
            <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />
            <Column
              field="name"
              header="Category"
              sortable
              filter
              filterPlaceholder={t("common_search_placeholder")}
              filterMatchMode={FilterMatchMode.CONTAINS}
              showFilterMenu={false}
            />
          </DataTable>
        </div>
      ) : null}
    </>
  );
};

export default CategoryLeftView;
